
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M57 21h-2v8h2a4 4 0 000-8zM45 44.12c-2.41 1.2-5.12 1.88-8 1.88s-5.59-.68-8-1.88c-5.36-2.66-9.2-7.91-9.89-14.12h35.78c-.69 6.21-4.53 11.46-9.89 14.12zM55 20v1c-3.31 0-6-2.69-6-6v-1H21.21c-.33 0-.67-.03-.99-.08-.05-.01-.1-.01-.14-.02-2.54-.46-4.65-2.42-5.02-5.03a6.001 6.001 0 015.14-6.81A3.002 3.002 0 0023 4h16c8.84 0 16 7.16 16 16z"}}),_c('circle',{attrs:{"cx":"30","cy":"25","r":"2","fill":"#3A4249"}}),_c('circle',{attrs:{"cx":"44","cy":"25","r":"2","fill":"#3A4249"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M37 54.861l9.363-5.107A4.003 4.003 0 0145 46.75v-.425a19.928 19.928 0 01-16 0v.425a4.003 4.003 0 01-1.363 3.004L37 54.861zM25.329 50.773l-1.615.341L19 55.828V61h17v-4.407z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M3 35a2 2 0 012 2 2 2 0 114 0 2 2 0 114 0V27a2 2 0 114 0v19h1v-2a4 4 0 014-4v10l-5 5v6H1V37a2 2 0 012-2zm60 20.382c-.042-.039-.078-.084-.12-.122a11.062 11.062 0 00-5.07-2.56l-9.139-1.927L38 56.593V61h25v-5.618zM56 59H43v-3h13v3z"}})])
          )
        }
      }
    